import type { IconNodeType } from './icons'
import { renderIconNode } from './render-icon-node'

export type IconSpriteSvgProps = {
	readonly iconMap: Map<string, IconNodeType>
	readonly providerId: string
}

const defaultSymbolProps: React.SVGProps<SVGSymbolElement> = {
	viewBox: '0 0 24 24',
	fill: 'none',
	stroke: 'currentColor',
	strokeWidth: 2,
	strokeLinecap: 'round',
	strokeLinejoin: 'round',
}

export function IconSpriteSvg({
	iconMap,
	providerId,
}: Readonly<IconSpriteSvgProps>) {
	return (
		<svg
			aria-hidden="true"
			style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
			focusable="false"
		>
			<defs>
				{[...iconMap.entries()]?.map(([name, node]) => (
					<symbol
						id={`${name}-${providerId}`}
						key={name}
						{...defaultSymbolProps}
					>
						{node ? renderIconNode(node) : null}
					</symbol>
				))}
			</defs>
		</svg>
	)
}
